/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class BigchangeJobTypesService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get all bigchange job types.
     * :param request: Django request
     * :return: HTTP Response with the list of job types
     * @returns any No response body
     * @throws ApiError
     */
    public bigchangeJobTypesRetrieve(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/bigchange-job-types/',
        });
    }

}
